export function CommentToolbar({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex w-full flex-row gap-1 rounded-t-[8px] bg-gray-100 p-1">
      {children}
    </div>
  )
}
